import { apiUrl } from "@/lib/api-base";
import { notifyApiError } from "@/lib/api-error";
import { getAuthToken } from "@/lib/auth";

export type ApiFetchInit = RequestInit & {
  auth?: boolean;
  timeoutMs?: number;
  notifyOnError?: boolean;
};

export async function apiFetch(path: string, init?: ApiFetchInit) {
  const { auth = true, timeoutMs, signal, notifyOnError = true, ...requestInit } = init ?? {};
  const token = auth ? getAuthToken() : "";
  const controller = timeoutMs ? new AbortController() : null;
  const timer = controller ? window.setTimeout(() => controller.abort(), timeoutMs) : null;
  const requestSignal = signal ?? controller?.signal;

  try {
    const response = await fetch(apiUrl(path), {
      ...requestInit,
      signal: requestSignal,
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...requestInit.headers
      }
    });

    if (!response.ok && notifyOnError) {
      await notifyApiError(response);
    }

    return response;
  } finally {
    if (timer) window.clearTimeout(timer);
  }
}
